export default __webpack_public_path__ + "static/media/request-icon.2d49541a.svg";